import { Badge, Button, Link, Select, useDisclosure } from "@chakra-ui/react";
import {
  MdOutlineRefresh,
  MdArrowBack,
  MdEdit,
  MdDeleteOutline,
  MdOutlineVisibility,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  closeAddPeoplesDrawer,
  closeEditPeoplesDrawer,
  closeShowDetailsPeoplesDrawer,
  openAddPeoplesDrawer,
  openEditPeoplesDrawer,
  openShowDetailsPeoplesDrawer,
} from "../../redux/reducers/misc";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import Loading from "../ui/Loading";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import moment from "moment";
import * as XLSX from "xlsx";

import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { usePagination, useSortBy, useTable } from "react-table";
import ClickMenu from "../ui/ClickMenu";
import ExcelEditDrawer from "../ui/Drawers/Edit Drawers/ExcelEditDrawer";
import ExcelDetailsDrawer from "../ui/Drawers/Details Drawers/ExcelDetailsDrawer";
import ExcelDrawer from "../ui/Drawers/Add Drawers/ExcelDrawer";
import { FcDatabase } from "react-icons/fc";
import { Input } from "@chakra-ui/react";
import Marquee from "react-fast-marquee";
import sampleCSV from "../../assets/bulk-upload-renewal.csv";

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from "@chakra-ui/react";
import { checkAccess } from "../../utils/checkAccess";
import axios from "axios";
import { HStack, VStack, Box, Flex, Text } from "@chakra-ui/react";
import PieChart from "../ui/Charts/PieChart";

const columns = [
  { Header: "", accessor: "select" },
  { Header: "Customer Name", accessor: "custumerName" },
  { Header: "Type of contract", accessor: "contractType" },
  { Header: "Contract Number", accessor: "contractNumber" },
  { Header: "Product Sold", accessor: "productName" },
  { Header: "Phone", accessor: "phnNumber" },
  { Header: "No. of Renewals", accessor: "renewalTimes" },
  { Header: "Renewal Mode", accessor: "mode" },
  { Header: "Status", accessor: "status" },
  { Header: "Remarks", accessor: "remarks" },
];

const Renewals = () => {
  const [cookies] = useCookies();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [dataId, setDataId] = useState();
  const [loading, setLoading] = useState(true);
  const [searchKey, setSearchKey] = useState("");
  const [dateWise, setDateWise] = useState([]);
  const [showUploadOptions, setShowUploadOptions] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [ids, setIds] = useState([]);
  const [peopleDeleteId, setPeopleDeleteId] = useState();

  const dispatch = useDispatch();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    state: { pageIndex, pageSize },
    pageCount,
    setPageSize,
  } = useTable(
    {
      columns,
      data: filteredData,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination
  );

  const {
    addPeoplesDrawerIsOpened,
    editPeoplesDrawerIsOpened,
    showDetailsPeoplesDrawerIsOpened,
  } = useSelector((state) => state.misc);
  const auth = useSelector((state) => state.auth);
  const { isAllowed, msg } = checkAccess(auth, "renewals");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();

  const baseURL = process.env.REACT_APP_BACKEND_URL;

  const fetchAllPeople = async () => {
    setSearchKey("");
    setData([]);
    setFilteredData([]);
    setLoading(true);

    try {
      const response = await fetch(baseURL + "renewal/all-records", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${cookies?.access_token}`,
        },
      });

      const res = await response.json();

      if (!res.success) {
        throw new Error(res.message || "Failed to fetch data");
      }

      setData(res.data || []);
      setFilteredData(res.data || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.message || "Failed to load data");
    }
  };

  const fetchAllDateWiseData = async () => {
    try {
      const response = await fetch(baseURL + "renewal/date-wise", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${cookies?.access_token}`,
        },
      });
      const data = await response.json();
      setDateWise(data?.data || []);
    } catch (error) {
      toast.error(`Something went wrong! ${error}`);
    }
  };

  useEffect(() => {
    fetchAllPeople();
    fetchAllDateWiseData();
  }, []);

  const addPeoplesHandler = () => {
    dispatch(openAddPeoplesDrawer());
  };

  const editHandler = (id) => {
    setDataId(id);
    dispatch(openEditPeoplesDrawer());
  };

  const showDetailsHandler = (id) => {
    setDataId(id);
    dispatch(openShowDetailsPeoplesDrawer());
  };

  const deleteHandler = async () => {
    if (!peopleDeleteId) {
      toast.error("No ID provided for deletion.");
      return;
    }

    try {
      const response = await fetch(
        `${baseURL}renewal/delete-record/${peopleDeleteId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies?.access_token}`,
          },
        }
      );

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (err) {
        throw new Error("Invalid response from server");
      }

      if (!data.success) {
        throw new Error(data.message);
      }

      toast.success(data.message);
      onClose();
      fetchAllPeople();
    } catch (err) {
      toast.error(err.message || "Deletion failed");
    }
  };

  const confirmDeleteHandler = () => {
    onOpen();
  };

  useEffect(() => {
    if (searchKey.trim() !== "") {
      const searchedData = data.filter(
        (d) =>
          d?.custumerName?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.contractType?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.contractNumber?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.productName?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.phnNumber?.includes(searchKey) ||
          d?.renewalTimes?.toString().includes(searchKey) ||
          d?.mode?.toLowerCase().includes(searchKey.toLowerCase()) ||
          d?.status?.toString().includes(searchKey.toLowerCase()) ||
          d?.remarks?.toLowerCase().includes(searchKey.toLowerCase())
      );
      setFilteredData(searchedData);
    } else {
      setFilteredData(data);
    }
  }, [searchKey, data]);

  const handleBulkDownload = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Renewals");
    XLSX.writeFile(wb, "Renewals.xlsx");
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".csv")) {
        toast.error("Invalid file type. Only .xlsx or .csv files are allowed.");
        return;
      }

      const formData = new FormData();
      formData.append("excel", file);

      fetch(`${baseURL}renewal/bulk-upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${cookies?.access_token}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.success) {
            toast.success("Excel data uploaded successfully!");
            fetchAllPeople();
          } else {
            throw new Error(result.message);
          }
        })
        .catch((error) => {
          toast.error(`Failed to upload: ${error.message}`);
        });
    }
  };

  const handleSelect = (e) => {
    const { checked, value } = e.target;
    if (checked) {
      setIds((prev) => [...prev, value]);
    } else {
      setIds((prev) => prev.filter((id) => id !== value));
    }
  };

  const handleBulkDelete = async (e) => {
    e.preventDefault();
    if (ids.length === 0) {
      toast.error("Please select renewals!");
    } else {
      try {
        await axios.delete(`${baseURL}renewal/delete-records`, {
          headers: {
            Authorization: `Bearer ${cookies?.access_token}`,
          },
          data: { ids },
        });
        toast.success("Selected records deleted successfully");
        setIds([]);
        fetchAllPeople();
      } catch (err) {
        toast.error(
          `Delete failed: ${err.response?.data?.message || err.message}`
        );
      }
    }
  };

  const filterDataByDate = (startDate, endDate) => {
    if (!startDate || !endDate) {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((item) => {
      const itemDate = new Date(item.createdAt);
      const start = new Date(startDate);
      const end = new Date(endDate);
      return itemDate >= start && itemDate <= end;
    });

    setFilteredData(filtered);
  };

  useEffect(() => {
    filterDataByDate(startDate, endDate);
  }, [startDate, endDate, data]);

  const calculateLeadStatus = (filteredData) => {
    const counts = {
      LIFEINSURANCE: 0,
      HealthIns: 0,
      PERSONALLOAN: 0,
      BUSINESSLOAN: 0,
      CCLIMIT: 0,
      CarIns: 0,
      Lic: 0,
      other: 0,
    };

    filteredData.forEach((data) => {
      switch (data?.contractType) {
        case "LIFE INSURANCE":
          counts.LIFEINSURANCE++;
          break;
        case "Health Ins":
          counts.HealthIns++;
          break;
        case "PERSONAL LOAN":
          counts.PERSONALLOAN++;
          break;
        case "BUSINESS LOAN":
          counts.BUSINESSLOAN++;
          break;
        case "CC LIMIT":
          counts.CCLIMIT++;
          break;
        case "Car Ins":
          counts.CarIns++;
          break;
        case "Lic":
          counts.Lic++;
          break;
        default:
          counts.other++;
      }
    });

    return counts;
  };

  const [statusCounts, setStatusCounts] = useState({
    LIFEINSURANCE: 0,
    HealthIns: 0,
    PERSONALLOAN: 0,
    BUSINESSLOAN: 0,
    CCLIMIT: 0,
    CarIns: 0,
    Lic: 0,
    other: 0,
  });

  useEffect(() => {
    const counts = calculateLeadStatus(filteredData);
    setStatusCounts(counts);
  }, [filteredData]);

  const statusChartData = {
    labels: [
      "LIFE INSURANCE",
      "HEALTH INSURANCE",
      "PERSONAL LOAN",
      "BUSINESS LOAN",
      "CC LIMIT",
      "Car Ins",
      "Lic",
      "Other",
    ],
    data: [
      statusCounts.LIFEINSURANCE,
      statusCounts.HealthIns,
      statusCounts.PERSONALLOAN,
      statusCounts.BUSINESSLOAN,
      statusCounts.CCLIMIT,
      statusCounts.CarIns,
      statusCounts.Lic,
      statusCounts.other,
    ],
    ChartColors: [
      "#F57D6A",
      "#F8D76A",
      "#54CA21",
      "#21CAC1",
      "#2170CA",
      "#C439EB",
      "#74b9ff",
      "#b2bec3",
    ],
  };

  return (
    <>
      {!isAllowed && (
        <Flex
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          fontSize="3xl"
          fontWeight="bold"
          color="#ff6f6f"
          gap={2}
        >
          {msg}
        </Flex>
      )}

      {isAllowed && (
        <Box px={{ base: 4, md: 9 }} py={8} bg="gray.50" minH="100vh">
          <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
          >
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  Delete Renewal Record
                </AlertDialogHeader>
                <AlertDialogBody>
                  Are you sure? This action will permanently delete the record
                  from all sections.
                </AlertDialogBody>
                <AlertDialogFooter>
                  <Button ref={cancelRef} onClick={onClose}>
                    Cancel
                  </Button>
                  <Button colorScheme="red" onClick={deleteHandler} ml={3}>
                    Delete
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>

          <VStack align="stretch" spacing={6}>
            {/* Header */}
            <Flex
              justify="space-between"
              align="center"
              flexWrap="wrap"
              gap={4}
            >
              <Text fontSize="2xl" fontWeight="extrabold" color="gray.800">
                Renewal List
              </Text>

              <HStack spacing={3}>
                <Input
                  placeholder="Search renewals..."
                  value={searchKey}
                  onChange={(e) => setSearchKey(e.target.value)}
                  size="md"
                  width={{ base: "full", md: "300px" }}
                  bg="white"
                  borderColor="gray.300"
                  _focus={{
                    borderColor: "#1640d6",
                    boxShadow: "0 0 0 1px #1640d6",
                  }}
                />
                <Button
                  leftIcon={<MdOutlineRefresh />}
                  onClick={fetchAllPeople}
                  colorScheme="blue"
                  variant="outline"
                >
                  Refresh
                </Button>
              </HStack>
            </Flex>

            {/* Controls */}
            <Flex
              direction={{ base: "column", md: "row" }}
              justify="space-between"
              align={{ base: "stretch", md: "center" }}
              gap={4}
              flexWrap="wrap"
              bg="white"
              p={4}
              borderRadius="lg"
              shadow="sm"
              border="1px"
              borderColor="gray.200"
            >
              <HStack spacing={3} flexWrap="wrap">
                <Button onClick={addPeoplesHandler} colorScheme="blue">
                  Add Renewal
                </Button>

                <Select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                  width="120px"
                >
                  <option value={5}>5 rows</option>
                  <option value={10}>10 rows</option>
                  <option value={20}>20 rows</option>
                  <option value={50}>50 rows</option>
                  <option value={100}>100 rows</option>
                  <option value={100000}>All</option>
                </Select>

                <Button
                  onClick={handleBulkDownload}
                  colorScheme="green"
                  variant="solid"
                >
                  Download Excel
                </Button>

                <Button
                  onClick={handleBulkDelete}
                  colorScheme="red"
                  variant="solid"
                  isDisabled={ids.length === 0}
                >
                  Delete Selected ({ids.length})
                </Button>
              </HStack>

              <HStack spacing={3} flexWrap="wrap">
                <Input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  size="md"
                />
                <Text>to</Text>
                <Input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  size="md"
                />

                <Box position="relative">
                  <input
                    type="file"
                    accept=".csv,.xlsx"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                    id="bulk-upload-input"
                  />
                  <Button
                    as="label"
                    htmlFor="bulk-upload-input"
                    colorScheme="teal"
                    cursor="pointer"
                  >
                    Bulk Upload
                  </Button>

                  <Button
                    as="a"
                    href={sampleCSV}
                    download
                    colorScheme="gray"
                    ml={2}
                  >
                    Sample CSV
                  </Button>
                </Box>
              </HStack>
            </Flex>

            {/* Upcoming Renewals Marquee */}
            {dateWise.length > 0 && (
              <Box
                bg="white"
                p={5}
                borderRadius="lg"
                shadow="md"
                border="1px"
                borderColor="gray.200"
              >
                <Text
                  fontWeight="semibold"
                  fontSize="lg"
                  mb={3}
                  color="gray.700"
                >
                  Upcoming Renewals
                </Text>
                <Marquee speed={60} pauseOnHover gradient={false}>
                  {dateWise.map((item, i) => (
                    <Box
                      key={i}
                      bg="blue.50"
                      color="blue.700"
                      px={5}
                      py={3}
                      mx={2}
                      borderRadius="full"
                      shadow="sm"
                      whiteSpace="nowrap"
                      fontWeight="medium"
                    >
                      📅 {moment(item.lastRenewalDate).format("DD MMM YYYY")} →{" "}
                      {item.contractType} → {item.productName} →{" "}
                      {item.custumerName}
                    </Box>
                  ))}
                </Marquee>
              </Box>
            )}

            {/* Table */}
            <Box
              bg="white"
              borderRadius="lg"
              shadow="lg"
              overflow="hidden"
              border="1px"
              borderColor="gray.200"
            >
              {loading ? (
                <Box p={20} textAlign="center">
                  <Loading />
                </Box>
              ) : filteredData.length === 0 ? (
                <VStack py={20} spacing={4}>
                  <FcDatabase size={80} />
                  <Text fontSize="2xl" fontWeight="semibold" color="gray.600">
                    No renewal records found
                  </Text>
                </VStack>
              ) : (
                <>
                  <TableContainer maxH="600px" overflowY="auto">
                    <Table variant="simple" size="md" {...getTableProps()}>
                      <Thead
                        bg="blue.600"
                        position="sticky"
                        top={0}
                        zIndex={10}
                      >
                        {headerGroups.map((headerGroup) => (
                          <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                              <Th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                color="white"
                                fontWeight="bold"
                                textAlign="center"
                                py={4}
                                textTransform="uppercase"
                                fontSize="sm"
                                letterSpacing="wide"
                              >
                                <Flex align="center" justify="center" gap={1}>
                                  {column.render("Header")}
                                  {column.isSorted && (
                                    <Box>
                                      {column.isSortedDesc ? (
                                        <FaCaretDown />
                                      ) : (
                                        <FaCaretUp />
                                      )}
                                    </Box>
                                  )}
                                </Flex>
                              </Th>
                            ))}
                            <Th
                              color="white"
                              textAlign="center"
                              fontWeight="bold"
                              py={4}
                            >
                              Actions
                            </Th>
                          </Tr>
                        ))}
                      </Thead>

                      <Tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Tr
                              {...row.getRowProps()}
                              _hover={{ bg: "gray.50" }}
                              transition="background 0.2s"
                            >
                              {row.cells.map((cell) => (
                                <Td
                                  {...cell.getCellProps()}
                                  textAlign="center"
                                  py={4}
                                  borderBottom="1px"
                                  borderColor="gray.200"
                                >
                                  {cell.column.id === "select" ? (
                                    <input
                                      type="checkbox"
                                      value={row.original._id}
                                      onChange={handleSelect}
                                      checked={ids.includes(row.original._id)}
                                    />
                                  ) : cell.column.id === "status" ? (
                                    <Badge
                                      colorScheme={
                                        row.original.status === "pending"
                                          ? "orange"
                                          : "green"
                                      }
                                      variant="subtle"
                                      px={3}
                                      py={1}
                                      borderRadius="full"
                                    >
                                      {row.original.status?.toUpperCase()}
                                    </Badge>
                                  ) : cell.column.id === "custumerName" ? (
                                    <Text fontWeight="medium" color="blue.600">
                                      {cell.value}
                                    </Text>
                                  ) : (
                                    cell.render("Cell")
                                  )}
                                </Td>
                              ))}

                              <Td py={4}>
                                <HStack justify="center" spacing={4}>
                                  <MdOutlineVisibility
                                    size={22}
                                    color="#3182ce"
                                    cursor="pointer"
                                    title="View"
                                    onClick={() =>
                                      showDetailsHandler(row.original._id)
                                    }
                                    _hover={{ transform: "scale(1.2)" }}
                                    transition="0.2s"
                                  />
                                  <MdEdit
                                    size={22}
                                    color="#d69e2e"
                                    cursor="pointer"
                                    title="Edit"
                                    onClick={() =>
                                      editHandler(row.original._id)
                                    }
                                    _hover={{ transform: "scale(1.2)" }}
                                    transition="0.2s"
                                  />
                                  <MdDeleteOutline
                                    size={22}
                                    color="#e53e3e"
                                    cursor="pointer"
                                    title="Delete"
                                    onClick={() => {
                                      setPeopleDeleteId(row.original._id);
                                      confirmDeleteHandler();
                                    }}
                                    _hover={{ transform: "scale(1.2)" }}
                                    transition="0.2s"
                                  />
                                </HStack>
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>

                  {/* Pagination */}
                  <Flex
                    justify="center"
                    align="center"
                    py={4}
                    gap={6}
                    bg="gray.50"
                  >
                    <Button
                      onClick={previousPage}
                      disabled={!canPreviousPage}
                      colorScheme="blue"
                      size="sm"
                    >
                      Previous
                    </Button>
                    <Text fontWeight="medium">
                      Page {pageIndex + 1} of {pageCount || 1}
                    </Text>
                    <Button
                      onClick={nextPage}
                      disabled={!canNextPage}
                      colorScheme="blue"
                      size="sm"
                    >
                      Next
                    </Button>
                  </Flex>
                </>
              )}
            </Box>

            {/* Pie Chart */}
            <Box
              bg="white"
              p={6}
              borderRadius="lg"
              shadow="md"
              border="1px"
              borderColor="gray.200"
            >
              <Text
                fontSize="xl"
                fontWeight="bold"
                mb={4}
                textAlign="center"
                color="gray.700"
              >
                Renewal Distribution by Contract Type
              </Text>
              <Box maxW="600px" mx="auto">
                <PieChart
                  labels={statusChartData.labels}
                  data={statusChartData.data}
                  ChartColors={statusChartData.ChartColors}
                />
              </Box>
            </Box>
          </VStack>

          {/* Drawers */}
          {addPeoplesDrawerIsOpened && (
            <ClickMenu
              top={0}
              right={0}
              closeContextMenuHandler={() => dispatch(closeAddPeoplesDrawer())}
            >
              <ExcelDrawer
                closeDrawerHandler={() => dispatch(closeAddPeoplesDrawer())}
                fetchAllPeople={fetchAllPeople}
              />
            </ClickMenu>
          )}

          {editPeoplesDrawerIsOpened && (
            <ClickMenu
              top={0}
              right={0}
              closeContextMenuHandler={() => dispatch(closeEditPeoplesDrawer())}
            >
              <ExcelEditDrawer
                dataId={dataId}
                closeDrawerHandler={() => {
                  dispatch(closeEditPeoplesDrawer());
                  fetchAllPeople();
                }}
              />
            </ClickMenu>
          )}

          {showDetailsPeoplesDrawerIsOpened && (
            <ClickMenu
              top={0}
              right={0}
              closeContextMenuHandler={() =>
                dispatch(closeShowDetailsPeoplesDrawer())
              }
            >
              <ExcelDetailsDrawer
                dataId={dataId}
                closeDrawerHandler={() =>
                  dispatch(closeShowDetailsPeoplesDrawer())
                }
              />
            </ClickMenu>
          )}
        </Box>
      )}
    </>
  );
};

export default Renewals;
